"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const finalize_1 = require("../../../app/dist/finalize");
exports.toolDef = {
    name: 'loom_finalize_doc',
    description: 'Finalize a draft document: sets status to "active". The permanent id and the filename are unchanged. Use this tool to finalize docs — do not edit weave files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Temporary (draft) document id to finalize' },
        },
        required: ['id'],
    },
};
async function handle(root, args) {
    const id = args['id'];
    // Resolve the primary (agent-supplied) tempId at the delivery boundary so a
    // wrong-but-close id surfaces a suggest-on-miss error before the use-case runs.
    // The finalize use-case keeps its injected findDocumentById for path resolution.
    const { id: resolvedId } = await (0, dist_1.resolveDocIdOrThrow)(root, id);
    const result = await (0, finalize_1.finalize)({ tempId: resolvedId }, {
        loadDoc: dist_1.loadDoc,
        saveDoc: dist_1.saveDoc,
        getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root),
        findDocumentById: dist_1.findDocumentById,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
